import {
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
	withUsagesEndpoint,
} from "@dgs/core";
import {
	OrganizationalUnitIndexResource,
	OrganizationalUnitSaveRequest,
	OrganizationalUnitUpdateResource,
} from "../types/organizationalUnit";

const baseKey = ["organizational-units"];

export const organizationalUnitService = {
	...withIndexEndpoint<OrganizationalUnitIndexResource>(baseKey),
	...withShowEndpoint<OrganizationalUnitUpdateResource>(baseKey),
	...withStoreEndpoint<OrganizationalUnitSaveRequest>(baseKey),
	...withUpdateEndpoint<OrganizationalUnitSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	...withUsagesEndpoint(baseKey),
};
